/* eslint-disable */
import Header from '../__header/Header';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import VideoLightbox from '../__utils/videoLightbox';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import forms from '../__utils/forms';
import vhUnit, { headerHeightVar } from '../__utils/vhUnit';
import AlertBar from '../__header/AlertBar';
import cookiesAlert from '../__utils/cookiesAlert';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		Header.init();
		Accordion.init();
		Video.init();
		VideoLightbox.init();
		mirrorHover();
		smoothScroll();
		headerHeightVar();
		Tables.init();
		cookiesAlert();
		vhUnit();
		AlertBar();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		vhUnit();
		headerHeightVar();
	},
	resized() {
		Header.resized();
		headerHeightVar();
		// Due to the fact that the header has different transitions, we have to delay the check of its height.
		setTimeout(() => {
			headerHeightVar();
		}, 1000);
		Tables.toggleShadow();
		vhUnit();
	},
	scrolled() {
		Header.handleScroll();
	},
	keyDown() {},
	mouseUp(e) {
		Header.hideOutsideClick(e);
	},
	gformRender() {
		forms();
	},
};
export default controller;
